<template>
<div class="loader">
    <div class="loading-spinner">
      <div v-if="!getMessage.toLowerCase().includes('error')" class="spinner" style="">
        <half-circle-spinner
          :animation-duration="1000"
          :size="80"
          color="#1997c6"
        />
      </div>
      <div class="message" :class="{'green': getMessage.toLowerCase().includes('success'), 'red': getMessage.toLowerCase().includes('error')}">
        {{getError && getError.Messege ? getError.Messege : getMessage.toLowerCase().includes('success') ? getMessage : getError ? getError : ''}}
      </div>
    </div>
</div>
    
</template>

<script>
import { mapGetters }         from 'vuex';
import {HalfCircleSpinner} from 'epic-spinners'

export default {
    props: ['width', 'height'],
    components: {
      HalfCircleSpinner,
    },
    name: 'Loader',

    data () {
        return {
            message: 'Hello',
        }
    },
    computed: 
        mapGetters([
          'getMessage',
          'getError'
        ]),
}
</script>

<style scoped>
.loader {
    z-index: 9999;
    background-color: #191b20;
    display:block;
    height:100%;
    position: absolute;
    bottom:0px;
    top: 0px;
    left: 0px;
    right: 0px;
    opacity: 0.7;
}
.loader-div{
    text-align: center;
    position: absolute;
    bottom:0px;
    top: 0px;
    left: 0px;
    right: 0px;
    }
.loading-spinner {
    padding-top: 65px;
    padding-bottom: 408px;
    width: 100%;
    display: block;
    position: absolute;
    top:0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    text-align: center;
  }
.spinner {
  display: inline-block;
  margin-top: 25px;
}
.message {
  margin-top: 10px; 
  color: #1997c6; 
  font-size: 18px;
}
.green {
  color: #1BC98E !important;
}
.red {
  color: #e64759 !important;
}
</style>